import { AVAILABLE_LANGS } from "@typings/globals";

export const langFromTag = (lang: string): AVAILABLE_LANGS => {
  if (!lang) {
    return "" as AVAILABLE_LANGS;
  }

  return lang.split("-")[0] as AVAILABLE_LANGS;
};
